import { booleanAttribute, Component, Input } from '@angular/core';
import { UrlSegment, UrlSerializer } from '@angular/router';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-tiered-menu-button',
  templateUrl: './tiered-menu-button.component.html',
  styleUrls: ['./tiered-menu-button.component.scss'],
  standalone: false
})
export class TieredMenuButtonComponent {
  @Input() label: string;
  @Input() iconLeft: string;
  @Input() iconRight: string;
  @Input({ transform: booleanAttribute }) textWhite: boolean = true;
  @Input() buttonClass: string = 'p-button-text';
  @Input() textClass: string;
  @Input() disabled: boolean = false;
  @Input() tooltip: string;
  public tieredMenuItems: MenuItem[] = [];

  constructor(private urlSerializer: UrlSerializer) {}

  @Input() set menuItems(items: MenuItem[]) {
    this.tieredMenuItems = items.map((item) => {
      if (item.routerLink) {
        const decodedUrl = this.decodeUrl(item.routerLink);
        return {
          ...item,
          routerLink: decodedUrl.segments,
          queryParams: decodedUrl.queryParams
        };
      } else {
        return item;
      }
    });
  }

  decodeUrl = (path: string) => {
    if (!path) return null;

    const urlTree = this.urlSerializer.parse(path);
    const segments = urlTree.root.children['primary'].segments.reduce((acc, curr: UrlSegment) => {
      acc.push(curr.path);
      return acc;
    }, []);
    const queryParams = urlTree.queryParams;
    return { segments: ['/', ...segments], queryParams };
  };
}
